import { BACKEND_BASE_URL } from '@/config.ts'
import axios from 'axios'

export const updateUsername = async (username: string) => {
  await axios.put(`${BACKEND_BASE_URL}/api/user-management/update`, {
    username,
  })
}
export const validate = async (username: string) => {
  const { data } = await axios.get(`${BACKEND_BASE_URL}/api/user-management/validate`, {
    params: {
      username,
    },
  })

  return data
}
